import React from "react";
import { Icon } from "../UIElements/Icon";

const CampaignsError = ({ error, onRetry }) => {
  const errorMessage =
    error?.message || "An error occurred while loading campaigns.";

  return (
    <div className="py-12 text-center">
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-500/20">
        <Icon name="AlertTriangle" className="h-8 w-8 text-red-400" />
      </div>
      <h3 className="mb-2 text-lg font-medium text-white">
        Failed to load campaigns
      </h3>
      <p className="mx-auto mb-6 max-w-md text-gray-400">{errorMessage}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="inline-flex items-center space-x-2 rounded-lg bg-purple-600 px-4 py-2 text-sm text-white transition-colors hover:bg-purple-700"
        >
          <Icon name="RefreshCw" className="h-4 w-4" />
          <span>Try Again</span>
        </button>
      )}
    </div>
  );
};

export default CampaignsError;
